module.exports = __webpack_public_path__ + "static/05-5e6c4d519d3861aae42828f5044431d1.png";